import actions      from './slideActions'
import mutations from './slideMutations'
import getters from './slideGetters'

import recruitMutations from './recruitMutations'

import slides       from '@/data/recruit/slides'
import stories      from '@/data/recruit/stories'

export default {
    namespaced: true,
    state: {
        slides,
        stories,
        current: {
            slide: 0,
            story: 0
        },
    },
    getters,
    actions: {
        ...actions,
    },
    mutations: {
        ...mutations,
        ...recruitMutations,
    }
}